var baseUrl = "/";
var baseStatic = "/dist/data"; //静态模拟接口数据
var templateStatic = "/dist/template/"; //导入模板文件
var ImgUrl = "/cloudec/storage/front/image/";

var dataArray = {
  /*************** 进销存 开始 ******************/

  // 在此新增接口

  /*************** 进销存 结束 ******************/

  /*************** 示例业务接口 开始   （后期需删除，请勿在里边新增！！！） ******************/
  /* 模拟数据 开始 */
  menuTree: {
    remote: baseStatic + "/menu.json",
  },
  headMenu: {
    remote: baseStatic + "/head.json",
  },
  searchTextList: {
    remote: baseStatic + "/searchTextList.json",
  },
  dataMapShow: {
    //首页订单合作分布图（gis）
    remote: baseStatic + "/dataMapShow.json",
  },

  /* 模拟数据 结束 */
  getNewMenu: {
    //获取菜单
    remote: baseUrl + "cloudec/fo/order/user/user/getNewMenu",
  },

  /* 订单农业 开始*/
  datacomfarmer: {
    //首页收购价格趋势（折线图）
    //remote: baseStatic + "/datacomfarmer.json"
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/FarmerTotal",
  },

  createImg: {
    //验证码图片
    remote: baseUrl + "cloudec/fo/order/user/user/createImg",
  },

  datacomcrop: {
    //首页收购价格趋势（折线图）
    remote: baseUrl + "cloudec/fo/order/SugarKindDepartController/SugarTotal",
  },

  datacomarea: {
    //首页收购价格趋势（折线图）
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/ZqTotal",
  },
  getFarmerListPageData: {
    //蔗农分页数据（折线图）
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/GetFarmerInfoPage",
  },
  getFarmerInfoById: {
    //蔗农数据
    remote:
      baseUrl + "cloudec/fo/order/FarmerInfoController/SelectFarmerInfoById",
  },
  ExportZn: {
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/exportZn",
  },
  exportDyZn: {
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/exportDyZn",
  },
  downzqloadErroInfo: {
    // 导出蔗区错误数据
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/downzqloadErroInfo",
  },
  downLoad: {
    remote: baseUrl + "cloudec/fo/order/ImportExcelController/downLoad", //导出错误导入数据
  },
  ExportZq: {
    // 导出榨区管理信息
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/exportZq",
  },
  ExportXz: {
    // 导出行政编号
    remote: baseUrl + "cloudec/fo/order/RegionManagementController/exportXz",
  },
  addFarmerInfo: {
    //蔗农数据
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/addFarmerInfo",
  },
  updateFarmerInfo: {
    //蔗农数据
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/updateFarmerInfo",
  },
  DeleteFarmerInfo: {
    //蔗农数据
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/DeleteFarmerInfo",
  },
  /*    GetSugarDepartInfoPage: {  //蔗农数据
            remote: baseUrl + "cloudec/fo/order/SugarKindDepartController/GetSugarDepartInfoPage"
        },*/
  AuditFarmerApprovalPass: {
    //蔗农数据
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/ApprovalPass",
  },
  AuditFarmerApprovalNoPass: {
    //蔗农数据
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/ApprovalNoPass",
  },
  selectFarmerInfoByCode: {
    //根据蔗农编码获取蔗农数据
    remote:
      baseUrl + "cloudec/fo/order/FarmerInfoController/selectFarmerInfoByCode",
  },
  GetSugarDepartInfoPage: {
    //获取品种信息列表
    remote:
      baseUrl +
      "cloudec/fo/order/SugarKindDepartController/GetSugarDepartInfoPage",
  },
  SelectSugarDepartInfoById: {
    //获取品种信息详情
    remote:
      baseUrl +
      "cloudec/fo/order/SugarKindDepartController/SelectSugarDepartInfoById",
  },
  addSugarDepartInfo: {
    //添加糖厂品种信息
    remote:
      baseUrl + "cloudec/fo/order/SugarKindDepartController/addSugarDepartInfo",
  },
  updateSugarDepart: {
    //修改糖厂品种信息
    remote:
      baseUrl + "cloudec/fo/order/SugarKindDepartController/updateSugarDepart",
  },
  DeleteSugarDepartInfo: {
    //删除糖厂品种信息
    remote:
      baseUrl +
      "cloudec/fo/order/SugarKindDepartController/DeleteSugarDepartInfo",
  },
  selectSugarDepartUnSelectInfoByDepartId: {
    //根据糖厂未选择的品种类型列表
    remote:
      baseUrl + "cloudec/fo/order/SugarKindDepartController/getVarietyList",
  },
  getRankPrice: {
    //根据品种等级获取价格
    remote: baseUrl + "cloudec/fo/order/SugarKindDepartController/getRankPrice",
  },
  getZjInfoWithCurrent: {
    //获取当前榨季的信息
    remote:
      baseUrl +
      "cloudec/fo/order/SugarKindDepartController/getZjInfoWithCurrent",
  },
  saveCropBatch: {
    remote:
      baseUrl + "cloudec/fo/order/SugarKindDepartController/saveCropBatch",
  },
  GetSugarName: {
    //全区品种名称
    remote: baseUrl + "cloudec/fo/order/SugarKindDepartController/GetSugarName",
  },
  GetDepartSugarName: {
    //全区品种名称
    remote:
      baseUrl + "cloudec/fo/order/SugarKindDepartController/GetDepartSugarName",
  },
  SugarKindDepartControllerGetSugarPrice: {
    //品种价格信息
    remote:
      baseUrl + "cloudec/fo/order/SugarKindDepartController/GetSugarPrice",
  },
  updateSugarInfo: {
    //修改品种信息
    remote: baseUrl + "cloudec/fo/order/SugarKindController/updateSugarInfo",
  },
  DeleteSugarInfo: {
    //删除品种信息
    remote: baseUrl + "cloudec/fo/order/SugarKindController/DeleteSugarInfo",
  },

  GetImageUrlByMongoId: {
    //跟据mongoid获取图片
    remote: baseUrl + "cloudec/fo/order/FileController/GetImageUrlByMongoId",
  },
  GetThumbImageUrlByMongoId: {
    //跟据mongoid获取缩略图
    remote:
      baseUrl + "cloudec/fo/order/FileController/GetThumbImageUrlByMongoId",
  },
  GetImaGetThumbImageUrlByMongoIdgeUrlByMongoId: {
    //跟据mongoid获取缩略图
    remote:
      baseUrl + "cloudec/fo/order/FileController/GetImaGetThumbImageUrlByMongoIdgeUrlByMongoId",
  },
   GetImaBase64List: {
    //电子印章获取缩略图
    remote:
      baseUrl + "cloudec/FadadaController/getImaBase64List",
  },
  GetPicUrlByMongoId: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrdersProof/GetPicUrlByMongoId",
  },

  ImportFarmerInfoExecl: {
    //蔗农信息excel导入
    remote:
      baseUrl + "cloudec/fo/order/ImportExcelController/ImportFarmerInfoExecl",
  },
  UploadBatchImportModifyData: {
    //蔗农信息excel导入
    remote:
      baseUrl +
      "cloudec/fo/order/ImportExcelController/uploadBatchImportModifyData",
  },
  uploadBatchDyImportModifyData: {
    //东亚蔗农信息excel导入
    remote:
      baseUrl +
      "cloudec/fo/order/ImportExcelController/uploadBatchDyImportModifyData",
  },
  getBankName: {
    //获取银行名称下拉值
    remote:
      baseUrl + "cloudec/fo/order/FarmerInfoController/getFarmerInfoBankName",
  },
  getBankCardType: {
    //获取银行卡类型下拉值
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/getBankCardType",
  },
  bankIdentify: {
    //银行卡有效性鉴定(接口待定义)
    remote: baseUrl + "cloudec/fo/order/FarmerInfoController/bankIdentify",
  },

  /* 订单农业 结束*/

  /* 首页 开始 */
  SelectZQInfoTotalTown: {
    // 首页区域订单合同签订情况列表
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/SelectZQInfoTotalTown",
  },
  RankPriceLineChart: {
    // 首页糖料蔗收购价格趋势折线图
    remote: baseUrl + "cloudec/fo/order/RankPriceController/RankPriceLineChart",
  },
  PlantPie: {
    // 首页糖料蔗种植情况饼图
    remote: baseUrl + "cloudec/fo/order/DepartInfoController/PlantPie",
  },
  QueryOcTotal: {
    // 首页已签订蔗农数、估产产量、种植面积
    remote: baseUrl + "cloudec/fo/order/OrderContractController/QueryOcTotal",
  },
  QueryEchartData: {
    // 首页echart地图分布点的数据展示
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/QueryEchartData",
  },
  GetJsonUrl: {
    // 获取首页echart地图json路径
    remote: baseUrl + "cloudec/fo/order/FileController/GetJsonUrl",
  },
  GetTotalOcnumAndFarmer: {
    // 获取首页合同总计和蔗农总计数量
    remote:
      baseUrl +
      "cloudec/fo/order/ZQInfoController/selectTotalOcnumAndFarmerSigned",
  },
  SelectMoreZQInfoTotalTown: {
    // 查看更多
    remote:
      baseUrl + "cloudec/fo/order/ZQInfoController/SelectMoreZQInfoTotalTown",
  },
  exportViewMore: {
    // 导出查看更多列表数据
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/exportViewMore",
  },
  xzNameTree: {
    // 查看更多跳转详情页左侧行政区划
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/xzNameTree",
  },
  /* 首页 结束 */

  /* ztree树图 开始 */
  ZtreeRegion: {
    // 行政区划树图
    remote: baseUrl + "cloudec/fo/order/RegionController/ZtreeRegion",
  },
  /* ztree树图 结束 */

  /* 合同 开始 */
  GetOrderContractPage: {
    // 合同列表
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/GetOrderContractPage",
  },
  getContractDel: {
    // 查询合同已删除列表
    remote: baseUrl + "cloudec/fo/order/OrderContractController/GetContractDel",
  },
  SelectOCInfoById: {
    // 获取单个合同详情
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/SelectOCInfoById",
  },
  changeOrderState: {
    // 更改合同状态
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/changeOrderState",
  },
  changeOrderState: {
    // 合同备案
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/changeOrderState",
  },
  changeBackOrderState: {
    // 合同退档操作
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/changeBackOrderState",
  },
  RecordOrderByDictidsList: {
    // 合同备案
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/RecordOrderByDictidsList",
  },
  verifyInfo: {
    // 合同详情中，信用验证
    remote: baseUrl + "cloudec/fo/order/VeriFyController/verifyInfo",
  },
  OcPrint: {
    // 合同打印列表中，每次点打印都调用一次
    remote: baseUrl + "cloudec/fo/order/OrderContractController/OcPrint",
  },
  GetPDFUrlByMongoId: {
    // 根据mongoid获取pdf的url路径
    remote: baseUrl + "cloudec/fo/order/FileController/GetPDFUrlByMongoId",
  },
  changeAllOrderState: {
    // 批量更改合同状态
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/changeAllOrderState",
  },
  transferAll: {
    // 全部平移
    remote: baseUrl + "cloudec/fo/order/contractTransfer/transferAll",
  },
  transferBatch: {
    // 批量平移
    remote: baseUrl + "cloudec/fo/order/contractTransfer/transferBatch",
  },
  submitTransfer: {
    // 操作栏平移合同
    remote: baseUrl + "cloudec/fo/order/contractTransfer/submitTransfer",
  },
  getStatusStatistics: {
    // 获取合同平移统计数据
    remote: baseUrl + "cloudec/fo/order/contractTransfer/getStatusStatistics",
  },
  getTransferById: {
    // 获取合同平移详情
    remote: baseUrl + "cloudec/fo/order/contractTransfer/getById",
  },
  factoryReturnTransfer: {
    //合同平移退回接口
    remote: baseUrl + "cloudec/fo/order/contractTransfer/factoryReturnTransfer",
  },
  approveTransfer: {
    //合同平移审批/驳回接口
    remote: baseUrl + "cloudec/fo/order/contractTransfer/approveTransfer",
  },
  RecordProcess: {
    //合同备案进度 流程
    remote: baseUrl + "cloudec/fo/order/OrderContractController/RecordProcess",
  },
  exportOc: {
    //导出合同数据
    remote: baseUrl + "cloudec/fo/order/OrderContractController/exportOc",
  },
  exportErrorOc: {
    //下载错误数据
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/exportErrorContractData",
  },
  orderContractPdfList: {
    //选择的合同PDF列表
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/orderContractPdflist",
  },
  downOrderContractPdfCheck: {
    //合同PDF下载验证
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/downOrderContractPdfCheck",
  },
  downOrderContractPdfFile: {
    //合同PDF下载
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/downOrderContractPdfFile",
  },
  numValid: {
    //判断合同导出数量是否过多
    remote: baseUrl + "cloudec/fo/order/OrderContractController/numValid",
  },
  updateOcInfo: {
    //修改合同信息
    remote: baseUrl + "cloudec/fo/order/OrderContractController/updateOcInfo",
  },
  getOcPlantInfoByDictId: {
    //根据id获取合同种植信息
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/getOcPlantInfoByDictId",
  },
  addOcPlantInfo: {
    //修改合同信息
    remote: baseUrl + "cloudec/fo/order/OrderContractController/addOcPlantInfo",
  },
  addPerformanceInfo: {
    //新增履约数据
    remote:
      baseUrl + "cloudec/fo/order/PerformanceController/addPerformanceInfo",
  },
  updatePerformanceInfo: {
    //修改履约数据
    remote:
      baseUrl + "cloudec/fo/order/PerformanceController/updatePerformanceInfo",
  },
  deletePerformanceInfo: {
    //删除履约数据
    remote:
      baseUrl + "cloudec/fo/order/PerformanceController/deletePerformanceInfo",
  },
  PerformanceInfo: {
    //履约数据回显
    remote: baseUrl + "cloudec/fo/order/PerformanceController/PerformanceInfo",
  },
  deleteOcPlantInfoByDictId: {
    //删除合同种植数据
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/deleteOcPlantInfoByDictId",
  },
  signedContractDown: {
    //已签约合同下载
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/signedContractDown",
  },
  downExcel: {
    //合同模板下载记录日志
    remote: baseUrl + "cloudec/fo/order/OrderContractController/downExcel",
  },
  getOcPlantInfoByDictId: {
    //合同模板下载记录日志
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/getOcPlantInfoByDictId",
  },
  updateOcPlantInfo: {
    //合同模板下载记录日志
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/updateOcPlantInfo",
  },
  factorySituation: {
    //获取进厂情况数据
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/factorySituation",
  },
  cancelAbout: {
    //取消合同履约
    remote: baseUrl + "cloudec/fo/order/OrderContractController/cancelAbout",
  },
  getDepartCurrentPresser: {
    //获取当前糖厂榨季
    remote:
      baseUrl +
      "cloudec/fo/order/OrderContractController/getDepartCurrentPresser",
  },
  GetContractNum: {
    //获取合同数量
    remote: baseUrl + "cloudec/fo/order/OrderContractController/GetContractNum",
  },
  /* 合同 结束 */

  /* 地图接口 开始 */
  SelectLindInfoByFarmerId: {
    // 根据蔗农id查询地块图形数据
    remote:
      baseUrl + "cloudec/fo/order/LandInfoController/SelectLindInfoByFarmerId",
  },
  getApplyPlot: {
    // 根据补贴表主键获取地块信息地块图形数据
    remote: baseUrl + "cloudec/fo/order/LandInfoController/getApplyPlot",
  },
  getLandPlot: {
    // 根据根据地块表主键获取地块图形数据
    remote: baseUrl + "cloudec/fo/order/LandInfoController/getLandPlot",
  },
  getOrderPlot: {
    // 根据合同表主键获取地块图形数据
    remote: baseUrl + "cloudec/fo/order/LandInfoController/getOrderPlot",
  },
  /* 地图接口 结束 */

  /* 文件 开始 */
  saveFile: {
    // 保存文件
    remote: baseUrl + "cloudec/fo/order/FileController/saveFile",
  },
  /* 图片上传 */
  saveImgFile: {
    // 图片上传
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/uploadFile",
  },
  saveImgFileDesc: {
    // 更新种子标签及使用说明
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/uploadDecsFile",
  },
  activeOrderByProofCheck: {
    // 附件上传后激活订单校验
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/activeOrderByProofCheck",
  },
  saveImgFileContract: {
    // 更新合同/引种证明
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/uploadContractFile",
  },
  saveImgFileQualityReport: {
    // 更新种茎质量检测报告
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/uploadQualityFile",
  },
  InsertPdfIDToDB: {
    // 保存pdf
    remote: baseUrl + "cloudec/fo/order/FileController/InsertPdfIDToDB",
  },
  ImportOCTempExcel: {
    // 保存excel
    remote:
      baseUrl + "cloudec/fo/order/ImportExcelController/ImportOCTempExcel",
  },
  ImportOCPerformanceExcel: {
    // 保存履约excel
    remote:
      baseUrl +
      "cloudec/fo/order/ImportExcelController/ImportOCPerformanceExcel",
  },
  QueryImportCount: {
    // 根据批次号查询剩余多少条合同待导入！
    remote: baseUrl + "cloudec/fo/order/ImportExcelController/QueryImportCount",
  },
  /* 文件 结束 */

  /* 蔗区管理 开始 */
  SelectZQInfoByCode: {
    // 获取蔗区详情
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/SelectZQInfoByCode",
  },
  updateZQInfo: {
    // 修改蔗区信息
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/updateZQInfo",
  },
  DeleteZQInfo: {
    // 删除蔗区信息
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/DeleteZQInfo",
  },
  ZqZtree: {
    // 获取蔗区信息树
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/ZqZtree",
  },
  ZqZtreeAll: {
    // 获取全部蔗区信息树
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/ZqZtreeAll",
  },
  uploadZqExeclFiler: {
    // Excel导入 保存
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/uploadZqExeclFiler",
  },
  GetZQInfoPage: {
    // 分页查询蔗区列表
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/GetZQInfoPage",
  },
  SelectZQInfoById: {
    // 主键查询
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/SelectZQInfoById",
  },
  addZQInfo: {
    // 新增蔗区
    remote: baseUrl + "cloudec/fo/order/ZQInfoController/addZQInfo",
  },
  getLandPhoto: {
    // 获取地块图片
    remote: baseUrl + "cloudec/fo/api/apiApp/getLandPhoto",
  },
  /* 蔗区管理 结束 */

  /* 良种补贴 开始 */
  getSubsidyList: {
    // 获取良种补贴 申请列表
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/getSubsidyList",
  },
  getSubsidyApplication: {
    // 获取补贴申请列表
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/getSubsidyApplication",
  },
  subsidyCollectPlotInfo: {
    // 获取补贴申请列表蔗农地块汇总信息
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/subsidyCollectPlotInfo",
  },
  subsidyCollectPlotInfoList: {
    // 获取补贴审批列表蔗农地块汇总信息
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/collectPlotInfoList",
  },
  getAlternativeContract: {
    // 获取备选合同列表
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/getAlternativeContract",
  },
  getAcceptanceFormulaList: {
    // 获取验收/公式列表
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/getAcceptanceFormulaList",
  },
  exportAcceptanceFormulaList: {
    // 导出验收列表
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyController/exportAcceptanceFormulaList",
  },
  exportPublicityFormList: {
    // 导出公示列表
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/exportPublicityFormList",
  },
  relatedContract: {
    // 地块绑定合同
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/relatedContract",
  },
  contractBinding: {
    // 地块申请
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/contractBinding",
  },
  improvedSeed: {
    // 地块全部申请
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/improvedSeed",
  },
  countUnfiledContractPlots: {
    // 统计全部申请列表未备案合同绑定的地块数量
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/countUnfiledContractPlots",
  },
  getSubsidyInfo: {
    //获取良种补贴申请详情
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/getSubsidyInfo",
  },
  factoryReportAll: {
    //糖厂全部上报
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/reportAll",
  },
  factoryReport: {
    //糖厂上报
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyAuditController/submitBySugarHouse",
  },
  factoryReturn: {
    //糖厂退回
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyAuditController/regressBySugarHouse",
  },
  governmentReport: {
    //乡镇政府通过
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyAuditController/governmentReport",
  },
  governmentReturn: {
    //乡镇政府退回
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyAuditController/governmentReturn",
  },
  updateApplySubsidyInfo: {
    //修改补贴申请信息（糖厂）
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/updateSubsidy",
  },
  getRecordOrderContractList: {
    // 获取蔗农已备案合同下拉列表
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyController/getRecordOrderContractList",
  },
  getRecordOrderContractListForLand: {
    // 获取蔗农名下当前榨季的合同下拉列表，如当前榨季无数据，则获取当前有效时间内的合同
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyController/getRecordOrderContractListForLand",
  },
  exportRecordCheckList: {
    // 导出验收表PDF接口
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/exportRecordCheckList",
  },
  exportRecordPublicityList: {
    // 导出公示表PDF接口
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyController/exportRecordPublicityList",
  },
  exportSubsidyList: {
    // 导出良种补贴申请excel列表
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/exportSubsidyList",
  },
  exportSubsidyApplyList: {
    // 导出良种补贴申请列表
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/exportSubsidyApplyList",
  },
  getCountByApplyStatus: {
    // 根据申请状态汇总数据
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/getCountByApplyStatus",
  },
  getSubsidyStatisticsByPage: {
    //补贴统计分页查询
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyStatisticsController/getSubsidyStatisticsByPage",
  },
  getRegionList: {
    // 获取乡镇、村、屯
    remote: baseUrl + "cloudec/fo/order/RegionController/getRegionList",
  },
  getLandPlotList: {
    remote: baseUrl + "cloudec/fo/subsidy/LandController/getLandPlotPage",
  },
  getLandPlotManagePage: {
    remote:
      baseUrl + "cloudec/fo/subsidy/LandController/getLandPlotManageListPage",
  },
  getLandPlotManageListCount: {
    remote:
      baseUrl + "cloudec/fo/subsidy/LandController/getLandPlotManageListCount",
  },
  getLandPlotManageListImg: {
    remote:
      baseUrl + "cloudec/fo/subsidy/LandController/getLandPlotManageListImg",
  },
  exportLandPlotList: {
    remote: baseUrl + "cloudec/fo/subsidy/LandController/exportLandPlotList",
  },
  exportXmlFile: {
    remote: baseUrl + "cloudec/fo/subsidy/LandController/exportXmlFile",
  },
  getLikeLandPlotList: {
    remote: baseUrl + "cloudec/fo/subsidy/LandController/getLikeLandPlotList",
  },
  saveSubsidyBatchFile: {
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyBatchFileController/saveSubsidyBatchFile",
  },
  qrySubsidyBatchFile: {
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidyBatchFileController/qrySubsidyBatchFile",
  },
  uploadLandPlotUpdateFiler: {
    //批量导入修改数据
    remote:
      baseUrl + "cloudec/fo/subsidy/LandController/uploadLandPlotUpdateFiler",
  },
  downLandPlotError: {
    //导出批量修改的错误数据
    remote: baseUrl + "cloudec/fo/subsidy/LandController/downLandPlotError",
  },
  saveLandPlotKmlFile: {
    // 批量导入Kml文件
    remote: baseUrl + "cloudec/fo/subsidy/LandController/saveLandPlotKmlFile",
  },
  downLandKmlError: {
    // 导出kml错误数据
    remote: baseUrl + "cloudec/fo/subsidy/LandController/downLandKmlError",
  },
  verifyLandPlotKmlFile: {
    // 校验Kml文件
    remote: baseUrl + "cloudec/fo/subsidy/LandController/verifyLandPlotKmlFile",
  },
  verifyLandPlotKmlFileByFarmer: {
    // 地块采集导入kml文件
    remote:
      baseUrl +
      "cloudec/fo/subsidy/LandController/verifyLandPlotKmlFileByFarmer",
  },
  exportApplySubsidyError: {
    // 导出错误数据
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/exportApplySubsidyError",
  },
  uploadContractExcel: {
    // 批量关联合同
    remote: baseUrl + "cloudec/fo/subsidy/SubsidyController/upload",
  },
  downloadFileSubsidy: {
    // 上传文件下载
    remote:
      baseUrl + "cloudec/fo/subsidy/SubsidyController/downloadFileSubsidy",
  },
  /* 良种补贴 结束 */

  /* 品种价格管理 开始 */
  GetRankPricePage: {
    // 获取品种价格列表
    remote: baseUrl + "cloudec/fo/order/RankPriceController/GetRankPricePage",
  },
  SelectRankPriceById: {
    // 获取品种价格详情
    remote:
      baseUrl + "cloudec/fo/order/RankPriceController/SelectRankPriceById",
  },
  addRankPrice: {
    // 新增品种价格详情
    remote: baseUrl + "cloudec/fo/order/RankPriceController/addRankPrice",
  },
  updateRankPrice: {
    // 修改品种价格详情
    remote: baseUrl + "cloudec/fo/order/RankPriceController/updateRankPrice",
  },
  DeleteRankPrice: {
    // 删除品种价格详情
    remote: baseUrl + "cloudec/fo/order/RankPriceController/DeleteRankPrice",
  },
  GetSugarPrice: {
    // 得到2019/2020榨季各个品种的价格
    remote: baseUrl + "cloudec/fo/order/RankPriceController/GetSugarPrice",
  },
  GetSeasonYear: {
    // 查询对应年份的榨季名称
    remote: baseUrl + "cloudec/fo/order/RankPriceController/GetSeasonYear",
  },
  updateUserSeasonYear: {
    // 登陆成功更新用户当前榨季为平台端默认榨季
    remote:
      baseUrl + "cloudec/fo/order/RankPriceController/updateUserSeasonYear",
  },
  GetZjList: {
    // 查询全部榨季
    remote: baseUrl + "cloudec/fo/order/RankPriceController/GetZjList",
  },
  UpdateInfoEx: {
    // 榨季切换更新seasonYear字段
    remote: baseUrl + "cloudec/fo/order/RankPriceController/UpdateInfoEx",
  },
  /* 品种价格管理 结束 */

  /* 糖厂数据填报 开始 */
  dataReport: {
    // 糖厂数据填报
    remote: baseUrl + "cloudec/fo/order/DepartInfoController/dataReport",
  },
  getZj: {
    // 获取当前糖厂榨季
    remote: baseUrl + "cloudec/fo/order/OrderContractController/getZj",
  },
  /* 糖厂数据填报 结束 */

  /* 公共模块 开始 */
  getAreaChildsById: {
    // 地址-省市区
    remote: baseUrl + "cloudec/platbsm/other/area/getAreaChildsById",
  },
  getDictCode: {
    // 根据 字典代码查询数据字典
    remote: baseUrl + "cloudec/platbsm/others/dictinfo/getDictCode",
  },
  getDictCodes: {
    // 根据 字典代码（支持多个） 查询数据字典
    remote: baseUrl + "cloudec/fo/others/dictinfo/selectByDictCodes",
  },
  /* 公共模块 结束 */

  /* 方案管理 开始 */
  sugarFactoryUploadPlan: {
    // 糖厂方案文件上传
    remote:
      baseUrl + "cloudec/fo/order/FilePlanController/sugarFactoryUploadPlan",
  },
  sugarFactoryFileShow: {
    // 糖厂方案文件查询
    remote:
      baseUrl + "cloudec/fo/order/FilePlanController/sugarFactoryFileShow",
  },
  downloadPromisesFile: {
    //下载失信惩戒机制方案文件
    remote:
      baseUrl + "cloudec/fo/order/FilePlanController/downloadPromisesFile",
  },
  uploadFileMO: {
    //方案文件上传fsId
    remote: baseUrl + "cloudec/fo/order/FilePlanController/uploadFileMO",
  },
  /* 方案管理 结束 */

  /* 短信验证 开始 */
  comFirm: {
    //确认提交
    remote: baseUrl + "cloudec/fo/order/MessageController/comFirm",
  },
  sendSmsCodeForRetrievePwdCode: {
    //获取验证码
    remote: baseUrl + "cloudec/fo/order/MessageController/sendMsg",
  },
  GoToNext: {
    //验证码通过进入下一步
    remote: baseUrl + "cloudec/fo/order/MessageController/GoToNext",
  },
  restPwdCode: {
    //找回密码-重置密码
    remote: baseUrl + "cloudec/fo/order/user/user/restPwdCode",
  },
  getToken: {
    //获取token
    remote: baseUrl + "cloudec/fo/order/user/user/getToken",
  },
  bindingsendMsg: {
    //绑定手机获取验证码
    remote: baseUrl + "cloudec/fo/order/MessageController/bindingsendMsg",
  },
  bindingphonesendMsg: {
    //更改绑定手机获取验证码
    remote: baseUrl + "cloudec/fo/order/MessageController/bindingphonesendMsg",
  },
  /* 短信验证 结束 */

  UpdateUserPassWord: {
    //修改用户登录密码
    remote: baseUrl + "cloudec/fo/order/user/user/UpdateUserPassWord",
  },

  /* 用户管理模块 开始 */
  doLogin: {
    // 用户登录
    remote: baseUrl + "cloudec/fo/order/user/user/doLogin",
  },
  doLogout: {
    // 用户登出
    remote: baseUrl + "cloudec/fo/order/user/user/doLogout",
  },
  getUserInfo: {
    // 获取用户信息
    remote: baseUrl + "cloudec/fo/order/user/user/logininfo",
  },
  getUserList: {
    remote: baseUrl + "cloudec/fo/order/user/user/getUserList",
  },
  switchEabled: {
    remote: baseUrl + "cloudec/fo/order/user/user/switchEnabled",
  },
  deleteUser: {
    remote: baseUrl + "cloudec/fo/order/user/user/accountDeleteUser",
  },
  getSingleUserInfo: {
    remote: baseUrl + "cloudec/fo/order/user/user/getSingleUserInfo",
  },
  //用户列表页面重置密码
  restPassWord: {
    remote: baseUrl + "cloudec/fo/order/user/user/SMSRturnPassword",
  },
  rePwd: {
    // 重置密码
    remote: baseUrl + "cloudec/fo/order/user/user/rePwd",
  },
  relation: {
    // 管理员联系方式
    remote: baseUrl + "cloudec/fo/order/user/user/relation",
  },
  getInternalDepartList: {
    remote: baseUrl + "cloudec/fo/order/DepartInfoController/getInternalDept",
  },
  updateUserInfo: {
    remote: baseUrl + "cloudec/fo/order/user/user/accountUpdata",
  },
  addUserInfo: {
    remote: baseUrl + "cloudec/fo/order/user/user/createUser",
  },
  logList: {
    remote:
      baseUrl + "cloudec/fo/order/JournalInfoController/GetJournalInfoPage",
  },
  importUserExcel: {
    remote: baseUrl + "cloudec/fo/order/user/user/inputUserExcel",
  },
  /* 用户管理模块 结束 */

  getRoleList: {
    // 角色列表
    remote: baseUrl + "cloudec/fo/order/user/user/getRoleList",
  },
  getRoleDetail: {
    // 角色详情
    remote: baseUrl + "cloudec/fo/order/user/role/getRole",
  },
  getAuthorizationRoleList: {
    // 角色授权
    remote: baseUrl + "cloudec/fo/order/user/role/getAuthorizationRoleList",
  },
  deleteRole: {
    // 角色列表
    remote: baseUrl + "cloudec/fo/order/user/role/deleteRole",
  },
  updateRole: {
    // 角色列表
    remote: baseUrl + "cloudec/fo/order/user/role/editRole",
  },
  addRole: {
    // 角色列表
    remote: baseUrl + "cloudec/fo/order/user/user/addRole",
  },
  getSysRoleListId: {
    // 角色列表
    remote: baseUrl + "cloudec/fo/order/user/res/getSysRoleListId",
  },

  /*内部部门管理 开始 */
  getInternalDept: {
    //获取内部部门
    remote: baseUrl + "cloudec/fo/order/DepartInfoController/getInternalDept",
  },
  addInternalDept: {
    //添加内部部门
    remote: baseUrl + "cloudec/fo/order/DepartInfoController/addInternalDept",
  },
  editInternalDept: {
    //修改内部部门
    remote: baseUrl + "cloudec/fo/order/DepartInfoController/editInternalDept",
  },
  deleteInternalDept: {
    //删除内部部门
    remote:
      baseUrl + "cloudec/fo/order/DepartInfoController/deleteInternalDept",
  },
  /*内部部门管理 结束 */

  /*种植信息管理 开始 */

  GetSugarContractBasePage: {
    //查询蔗农信息列表
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/GetSugarContractBasePage",
  },
  addInterFarmer: {
    //新增蔗农
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/addInterFarmer",
  },
  getFarmerCode: {
    //获取蔗农编码
    remote:
      baseUrl + "cloudec/fo/order/SugarContractBaseImpController/getFarmerCode",
  },
  getSugarKindName: {
    //品种名称
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/getSugarKindName",
  },
  getPlantPeriodName: {
    //植期名称
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/getPlantPeriodName",
  },
  selectSugarContractBaseById: {
    //主键查询
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/selectSugarContractBaseById",
  },
  DeleteSugarContractInfo: {
    //删除蔗农信息
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/DeleteSugarContractInfo",
  },
  DeleteAllSugarContractInfo: {
    //批量删除蔗农信息
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/DeleteAllSugarContractInfo",
  },
  updateSugarContract: {
    //修改
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/updateSugarContract",
  },
  ImportContractBaseImpExcel: {
    // 导入蔗农种植临时数据
    remote:
      baseUrl +
      "cloudec/fo/order/ImportExcelController/ImportContractBaseImpExcel",
  },
  exportSugarContractBaseImpList: {
    // 导出蔗农种植信息excel模板列表
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/exportSugarContractBaseImpList",
  },
  exportSugarContractBaseImpData: {
    // 导出蔗农种植列表数据
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/exportSugarContractBaseImpData",
  },
  downLoadError: {
    // 导出错误数据
    remote:
      baseUrl + "cloudec/fo/order/SugarContractBaseImpController/downLoadError",
  },
  /*种植信息管理 结束 */

  /*蔗农地块信息报表 开始 */
  exportPlotInformationData: {
    // 导出蔗农地块信息报表
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/exportPlotInformationData",
  },
  uploadPlotInformationUpdateFiler: {
    // 导入导出蔗农地块信息报表修改的数据
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/uploadPlotInformationUpdateFiler",
  },
  collectPlotInfo: {
    // 汇总蔗农数量、地块数量、面积
    remote:
      baseUrl + "cloudec/fo/order/PlotInformationController/collectPlotInfo",
  },
  /*蔗农地块信息报表 结束 */

  /*电子签章 开始 */
  authorizationList: {
    //签章授权列表接口
    remote: baseUrl + "cloudec/FadadaController/authorizationList",
  },
  getUserConfiguration: {
    //查询用户配置
    remote: baseUrl + "cloudec/FadadaController/getUserList",
  },
  saveUserConfiguration: {
    //保存用户配置
    remote: baseUrl + "cloudec/FadadaController/saveUserConfiguration",
  },
  deleteOcTemp: {
    //删除合同模板
    remote: baseUrl + "cloudec/FadadaController/deleteOcTemp",
  },
  ocTempList: {
    //合同模板列表
    remote: baseUrl + "cloudec/FadadaController/ocTempList",
  },
  updateOcTempState: {
    //更改合同模板状态
    remote: baseUrl + "cloudec/FadadaController/updateOcTempState",
  },
  updateSignState: {
    //更改签章状态
    remote: baseUrl + "cloudec/FadadaController/updateSignState",
  },
  uploadOcTemp: {
    //上传合同模板
    remote: baseUrl + "cloudec/FadadaController/uploadOcTemp",
  },
  getFactoryAuthInfo: {
    //获取内部部门
    remote: baseUrl + "cloudec/FadadaController/getFactoryAuthInfo",
  },
  getBeforeAuthSign: {
    //开通电子签章
    remote: baseUrl + "cloudec/FadadaController/getBeforeAuthSign",
  },
  setSignNoRemind: {
    //不再提醒自动签署续期
    remote: baseUrl + "cloudec/FadadaController/setSignNoRemind",
  },
  getSignCertExpiry: {
    //获取签署续期证书有效期
    remote: baseUrl + "cloudec/FadadaController/getSignCertExpiry",
  },
  addSignature: {
    //印章上传功能
    remote: baseUrl + "cloudec/FadadaController/addSignature",
  },
  getAutoSignStatus: {
    //查看自动签署授权状态
    remote: baseUrl + "cloudec/FadadaController/getAutoSignStatus",
  },
  factoryAuthentication: {
    //糖厂认证
    remote: baseUrl + "cloudec/FadadaController/factoryAuthentication",
  },
  getImaBase64List: {
    //获取默认印章
    remote: baseUrl + "cloudec/FadadaController/getImaBase64List",
  },
  GetSugerFactoryInfoByPower: {
    //糖厂订单合同签订核准备案进展统计新增列表
    remote:
      baseUrl +
      "cloudec/fo/contract/ContractProgressController/GetSugerFactoryInfoByPower",
  },
  getCurUserRegion: {
    //查询糖厂端当前用户区域信息
    remote:
      baseUrl +
      "cloudec/fo/contract/ContractProgressController/getCurUserRegionDataForFactoryStatistics",
  },
  getLastUpdatedTime: {
    //查询糖厂端当前用户区域信息
    remote:
      baseUrl +
      "cloudec/fo/contract/ContractProgressController/getLastUpdateTimeForFactoryStatistics",
  },
  getallfactoryinfo: {
    //蔗农数据
    remote:
      baseUrl +
      "cloudec/fo/contract/ContractProgressController/getallfactoryinfo",
  },
  addfactroyinfo: {
    //新增糖厂订单合同签订核准备案进展统计
    remote:
      baseUrl + "cloudec/fo/contract/ContractProgressController/addfactroyinfo",
  },
  DownLoadExcel: {
    //下载糖厂订单合同签订核准备案进展统计表
    remote:
      baseUrl + "cloudec/fo/contract/ContractProgressController/DownLoadExcel",
  },
  delImagesBase64: {
    //删除默认印章
    remote: baseUrl + "cloudec/FadadaController/delImagesBase64",
  },
  SelectFadadaPdfTemplateById: {
    //主键ID查询
    remote: baseUrl + "cloudec/FadadaController/SelectFadadaPdfTemplateById",
  },
  updateFadadaPdfTemplate: {
    //修改合同管理时间
    remote: baseUrl + "cloudec/FadadaController/updateFadadaPdfTemplate",
  },
  selectPageList: {
    //企业合同用章列表查询
    remote: baseUrl + "cloudec/contractReview/selectPageList",
  },
  selectSum: {
    //企业合同用章标签页数字统计
    remote: baseUrl + "cloudec/contractReview/selectSum",
  },
  restoreDelPlot: {
    //恢复删除地块
    remote: baseUrl + "cloudec/fo/subsidy/LandController/restoreDelPlot",
  },
  getEsignCostStatistics: {
    //费用统计汇总
    remote:
      baseUrl +
      "cloudec/fo/order/CostStatisticsController/getEsignCostStatistics",
  },
  getEsignCostStatisticsDetail: {
    //费用统计明细
    remote:
      baseUrl +
      "cloudec/fo/order/CostStatisticsController/getEsignCostStatisticsDetail",
  },

  /*电子签章 结束 */

  /* 行政区划模块 开始 */
  GetRegion: {
    // 获取
    remote: baseUrl + "cloudec/fo/order/RegionManagementController/GetRegion",
  },
  SelectRegionById: {
    // 获取
    remote:
      baseUrl + "cloudec/fo/order/RegionManagementController/SelectRegionById",
  },
  ZtreeAllRegion: {
    // 行政区划树图
    remote: baseUrl + "cloudec/fo/order/RegionController/ZtreeAllRegion",
  },
  /* 行政区划模块 结束 */
  /*************** 示例业务接口 结束   （后期需删除，请勿在里边新增！！！） ******************/

  /* 地块采集 start */
  ZqFarmerZtree: {
    // 蔗区蔗农树
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/ZqFarmerZtree",
  },
  QueryFarmerLandPlots: {
    // 查询蔗农地块信息
    remote:
      baseUrl + "cloudec/fo/order/PlotCollectController/queryFarmerLandPlots",
  },
  GetLatAndLong: {
    // 根据部门编号获取所在地经纬度
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/getLatAndLong",
  },
  getSubsidyType: {
    // 查询补贴类型字典
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/getSubsidyType",
  },
  getSubsidyMode: {
    // 查询补贴方式字典
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/getSubsidyMode",
  },
  excuteOneLandRisk: {
    // 计算单块地风险值
    remote:
      baseUrl + "cloudec/fo/order/PlotInformationController/excuteOneLandRisk",
  },
  QueryFarmerInfo: {
    // 查询蔗农属性
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/queryFarmerInfo",
  },
  QueryZTreeFarmer: {
    // 查询蔗农属性
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/searchFarmer",
  },
  DeleteFarmerLand: {
    // 删除地块
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/deleteFarmerLand",
  },
  UpdateFarmerLand: {
    // 修改地块
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/updateFarmerLand",
  },
  AddFarmerLand: {
    // 新增地块
    remote: baseUrl + "cloudec/fo/order/PlotCollectController/addFarmerLand",
  },
  GetPlotInformation: {
    //查询蔗农地块报表
    remote:
      baseUrl + "cloudec/fo/order/PlotInformationController/getPlotInformation",
  },
  SetSeasonTranslation: {
    //同步上榨季数据
    remote:
      baseUrl + "cloudec/fo/order/PlotInformationController/seasonTranslation",
  },
  CheckUserAuthorityOfTranslation: {
    //查询用户平移榨季的权限
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/checkUserAuthorityOfTranslation",
  },
  ExportLandPlotInfoList: {
    //蔗农地块信息报表导出地块列表数据
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/exportLandPlotInfoList",
  },
  ExportXmlFileInfo: {
    //蔗农地块信息报表导出地块列表kml
    remote:
      baseUrl + "cloudec/fo/order/PlotInformationController/exportXmlFileInfo",
  },
  appCollectTotalPage: {
    //APP采集统计页面
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/appCollectTotalPage",
  },
  exportAppCollectTotal: {
    //APP采集统计页面列表下载
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/exportAppCollectTotal",
  },
  appCollectTotalDetails: {
    //APP采集统计页面详情
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/appCollectTotalDetails",
  },
  exportAppCollectTotalDetails: {
    //APP采集统计页面详情列表导出
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/exportAppCollectTotalDetails",
  },
  getFarmerOcnumList: {
    //地块采集查询蔗农合同列表
    remote:
      baseUrl + "cloudec/fo/order/PlotCollectController/getFarmerOcnumList",
  },

  getFarmerPlotTotalPage: {
    //蔗农地块汇总数据分页查询Page
    remote:
      baseUrl + "cloudec/fo/order/PlotCollectController/getFarmerPlotTotalPage",
  },
  refreshFarmerPlotTotalPage: {
    //刷新当前糖厂下蔗农地块汇总信息
    remote:
      baseUrl +
      "cloudec/fo/order/PlotCollectController/refreshFarmerPlotTotalPage",
  },
  exportFarmerPlotTotal: {
    //导出蔗农地块汇总列表数据
    remote:
      baseUrl + "cloudec/fo/order/PlotCollectController/exportFarmerPlotTotal",
  },
  exportAllFarmerPlotTotal: {
    //导出全部蔗农地块汇总列表数据
    remote:
      baseUrl +
      "cloudec/fo/order/PlotCollectController/exportAllFarmerPlotTotal",
  },
  doGetAllActivePlantPeriods: {
    //查询系统所有有效植期
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/getAllActivePlantPeriods",
  },
  batchExcuteLandRisk: {
    //批量计算地块风险值
    remote:
      baseUrl +
      "cloudec/fo/order/PlotInformationController/batchExcuteLandRisk",
  },

  /* 地块采集 end */
  /* 异步导出 start 若其他端需要搭建离线下载服务，则参考 Config.prototype.get 方法，挪代码到对应的配置服务去 */
  getExportList: {
    remote: baseUrl + "offlineExportService/export/list",
  },
  downloadFile: {
    remote: baseUrl + "offlineExportService/export/downloadFile",
  },
  doExport: {
    remote: baseUrl + "offlineExportService/export/doExport",
  },
  doDelete: {
    remote: baseUrl + "offlineExportService/export/deleteRecord",
  },
  uploadFile: {
    //异步 上传
    remote: baseUrl + "offlineExportService/upload/uploadFile",
  },
  LogUpload: {
    //查询最新更新10条数据
    remote: baseUrl + "offlineExportService/upload/LogUpload",
  },
  PeripheryLand: {
    // 查询周边地块
    remote: baseUrl + "cloudec/fo/subsidy/LandController/getPeripheryLand",
  },
  /* 异步导出 end */

  /* 合同用章start */
  companiesUseChapter: {
    remote: baseUrl + "cloudec/FadadaController/companiesUseChapter",
  },

  batchCompaniesUseChapter: {
    remote: baseUrl + "cloudec/FadadaController/batchCompaniesUseChapter",
  },
  /* 合同用章end */

  /* 电子合同复核start */
  doReviewContract: {
    remote: baseUrl + "cloudec/contractReview/doReview",
  },
  doInvalidContract: {
    remote: baseUrl + "cloudec/contractReview/cancel",
  },
  doDeleteContract: {
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/deleteContract",
  },
  deleteCompleteContract: {
    remote:
      baseUrl +
      "cloudec/fo/order/SugarContractBaseImpController/deleteCompleteContract",
  },

  downloadContractPdf: {
    //合同pdf下载
    remote:
      baseUrl + "cloudec/fo/order/OrderContractController/downloadContractPdf",
  },
  /* 电子合同复核end */

  /* 退桉还蔗start */
  selectEucalyptFactory: {
    //退桉还蔗列表页
    remote: baseUrl + "cloudec/fo/EucalyptController/selectEucalyptFactory",
  },
  addEucalyptInfo: {
    //退桉还蔗新增修改
    remote: baseUrl + "cloudec/fo/EucalyptController/addEucalyptInfo",
  },
  ztree: {
    //退桉还蔗新增修改
    remote: baseUrl + "cloudec/fo/EucalyptController/ztree",
  },
  getDepartUserInfo: {
    //地块采集获取农务员信息
    remote: baseUrl + "cloudec/fo/order/UserInfoController/getDepartUserInfo",
  },
  /* 退桉还蔗end */
  /* 消息管理 start */
  getMessageList: {
    // 获取消息列表
    remote:
      baseUrl + "cloudec/fo/msgManager/MsgController/getMessageListByPort",
  },
  /* 消息管理 end */
  /* 综合报表 start */
  getSubsidyReportFactoryXzCode: {
    //获取下拉行政列表
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidReportController/getSubsidyReportFactoryXzCode",
  },
  getSubsidyReportFactory: {
    //糖厂查询列表数据
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidReportController/getSubsidyReportFactory",
  },
  getSubsidyReportByEnt: {
    // 按集团
    remote:
      baseUrl +
      "cloudec/fo/subsidy/SubsidReportController/getSubsidyReportByEnt",
  },
  /* 综合报表 end */
  /* 参数设置 start */
  getAppParameterLog: {
    // 参数操作日志
    remote: baseUrl + "cloudec/fo/api/appParameter/getAppParameterLog",
  },
  addAppParameter: {
    // 参数操作日志
    remote: baseUrl + "cloudec/fo/api/appParameter/addAppParameter",
  },
  /* 参数设置 end */

  /* 种苗订单管理start */
  GetSeedlingOrdersPicPage: {
    remote:
        baseUrl + "cloudec/fo/order/seedlingOrders/getSeedlingOrdersPicPage",
  },
  GetSeedlingOrders: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getSeedlingOrdersPage",
  },
  getFarmerPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getFarmerPage",
  },
  updateOrdersInfo: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/updateOrdersInfo",
  },
  seedlingOrdersStatistics: {
    remote:
      baseUrl + "cloudec/fo/order/seedlingOrders/seedlingOrdersStatistics",
  },
  saleSeedlingOrdersStatistics: {
    remote:
      baseUrl + "cloudec/fo/order/seedlingOrders/saleSeedlingOrdersStatistics",
  },
  exportOrders: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/exportOrders",
  },
  exportErrorOrders: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/exportErrorOrders",
  },
  ValidSeedlingOrders: {
    remote:
      baseUrl + "cloudec/fo/order/seedlingOrders/seedlingOrdersStatistics",
  },
  getOrganList: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getOrganList",
  },
  uploadAnalyzeFile: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/uploadAnalyzeFile",
  },
  getSeedlingOrdersProofPage: {
    remote:
      baseUrl +
      "cloudec/fo/order/seedlingOrdersProof/getSeedlingOrdersProofPage",
  },
  getSeedlingDecsProofPage: {
    remote:
      baseUrl + "cloudec/fo/order/seedlingDecsProof/getSeedlingDecsProofPage",
  }, //获取订单种子标签及使用说明列表
  deleteProof: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrdersProof/deleteProof",
  },
  deleteDescProof: {
    remote: baseUrl + "cloudec/fo/order/seedlingDecsProof/deleteProof",
  }, //删除种子标签及使用说明
  batchInsertOrdersProof: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/batchInsertOrdersProof",
  }, //批量导入购销凭证
  batchInsertDecsProof: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/batchInsertDecsProof",
  }, //批量导入种子标签及说明
  getQualifyProofPageSugar: {
    remote:
      baseUrl + "cloudec/fo/order/seedlingOrders/getQualifyProofPageSugar",
  },
  uploadQualifyProofFile: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/uploadQualifyProofFile",
  },
  deleteQualifyProof: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/deleteQualifyProof",
  },
  getOrderByCode: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getOrderByCode",
  },
  perationSeedingsOrder: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/perationSeedingsOrder",
  },
  getDepartPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getDepartPage",
  },
  getSaleSeedlingsPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getSaleSeedlingsPage",
  },
  getSeedlingOrderSalesStatus: {
    remote:
      baseUrl +
      "cloudec/fo/order/DepartInfoController/GetSeedlingOrderSalesStatus",
  },
  getPurchaseOrderPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getPurchaseOrderPage",
  },
  getSaleOrdersPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getSaleOrdersPage",
  },
  batchUpdateOrders: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/batchUpdateOrders",
  },
  purchaseOrdersStatistics: {
    remote:
      baseUrl + "cloudec/fo/order/seedlingOrders/purchaseOrdersStatistics",
  },
  getFarmerOrdersPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getFarmerOrdersPage",
  },
  getFarmerOrdersSummary: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getFarmerOrdersSummary",
  },
  /* 种苗订单管理end */
  /* 商品中心start */
  getSeedlingConfigPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getSeedlingConfigPage",
  },
  seedlingConfigUpdating: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/seedlingConfigUpdating",
  },
  restrictionPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/restrictionPage",
  },
  changeInfo: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/changeInfo",
  },
  /* 商品中心end */
  getPuraseSaleInfoPage: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/getPuraseSaleInfoPage",
  }, //购销信息列表
  createInfo: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/createInfo",
  }, //创建购销信息
  deleteInfo: {
    remote: baseUrl + "cloudec/fo/order/seedlingOrders/deleteInfo",
  }, //删除购销信息
  GetSugarInfoPage: {
    remote: baseUrl + "cloudec/fo/order/SugarKindController/GetSugarInfoPage",
  }, //创建购销信息品种列表
  /* 基础参数start */
  getPlatRankPage: {
    // 集团或糖厂端查询品种
    remote:
      baseUrl +
      "cloudec/fo/basicParam/SugarRankController/GetSugarDepartInfoPage",
  },
  UpdateDepartSugarInfo: {
    // 集团或糖厂端修改品种信息
    remote:
      baseUrl +
      "cloudec/fo/basicParam/SugarRankController/UpdateDepartSugarInfo",
  },
  getPlantPeriodPage: {
    // 获取植期列表
    remote:
      baseUrl +
      "cloudec/fo/basicParam/PlantPeriodController/getPlantPeriodPage",
  },
  UpdateEntPlantInfo: {
    // 集团或糖厂端修改植期信息
    remote:
      baseUrl +
      "cloudec/fo/basicParam/PlantPeriodController/UpdateEntPlantInfo",
  },
  getSugarSubsidyPage: {
    // 获取糖厂补贴方式列表
    remote:
      baseUrl +
      "cloudec/fo/basicParam/SugarhouseSubsidyController/getSugarSubsidyPage",
  },
  updateSugarSubsidyInfo: {
    // 集团或糖厂端修改糖厂补贴类型
    remote:
      baseUrl +
      "cloudec/fo/basicParam/SugarhouseSubsidyController/updateEntSubsidyInfo",
  },
  oneClickByDepart: {
    // 甘蔗品种一键操作
    remote:
      baseUrl + "cloudec/fo/basicParam/SugarRankController/oneClickByDepart",
  },
  /* 基础参数 end */
  doLoginSugar: { // 免登录用户登录
    remote: baseUrl + 'cloudec/fo/order/user/user/doLoginSugar'
  },

  /* 下载文件 end */
  downloadProofFile: { //
    remote: baseUrl + 'cloudec/fo/order/seedlingOrders/downloadProofFile'
  },
  /* 查询任务列表 */
  getTaskList: { //
    remote: baseUrl + 'cloudec/fo/order/relatedContractTask/getTaskList'
  },
  /* 发起自动关联合同任务  */
  startTask: { //
    remote: baseUrl + 'cloudec/fo/order/relatedContractTask/startTask'
  },
  /* 获取企业信息  */
  getDetoxEnterprisePage: { //
    remote: baseUrl + 'cloudec/fo/order/seedlingOrders/getDetoxEnterprisePage'
  },
};

function Config(type) {
  this.type = type || REMOTE;
}

Config.prototype.get = function (name, type) {
  var dataCfg = dataArray[name];
  if (typeof type == "undefined") {
    type = this.type;
  }
  if (!dataCfg) return "";
  if (type == REMOTE) {
    var url = dataCfg.remote;
    var curUrl = window.location.href;
    // 同一接口测试需注释~~~
    var ifOfflineExport =
      (curUrl.indexOf("localhost") > -1 || curUrl.indexOf("127.0.0.1") > -1) &&
      url.indexOf("offlineExportService") > -1; //是离线导出服务的，则需要更换端口号
    if (ifOfflineExport) {
      url = "http://" + document.domain + ":8430" + url;
    }
    return url;
  } else if (type == STATIC) {
    return dataCfg.static;
  }
};

var cache = {};
var STATIC = 1,
  REMOTE = 0;
var cfg = new Config(REMOTE);
cfg.cache = cache;
module.exports = cfg;



// WEBPACK FOOTER //
// ./js/common/config.js